import React,{ useEffect, useState } from 'react';
import { queuedApiFetch } from '../api';

function JACConsultant() {
    const [powerBiUrl, setPowerBiUrl] = useState('');
    const url_name='JAC_ASS_Term_Consultant';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const requestOptions = { method: 'GET' };
                const data = await queuedApiFetch(
                    `/project/get_powerbi_url?url_name=${url_name}`,
                    requestOptions
                );

                if (
                    data?.apistatus?.Status_Code === 200 &&
                    data?.apistatus?.Status_Description?.toLowerCase() === 'success'
                ) {
                    setPowerBiUrl(data.data); 
                } else {
                    console.error('Failed to load Power BI URL');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            } 
        };

        fetchData();
    }, []);


    return (

        <iframe title="Power BI Report" src={powerBiUrl} sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

    );
}

export default JACConsultant;

// import React from 'react';

// function JACConsultant() {
//   // const powerBiUrl = "https://app.powerbi.com/reportEmbed?reportId=92d3b3ea-4315-41b6-ae1e-139948f40e90&autoAuth=true&ctid=b161c897-0ae2-42a0-be86-8f7e36f2049f";
//   const powerBiUrl = process.env.REACT_APP_JAC_ASS_Term_Consultant;

//   return (
    
//       <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>
    
//   );
// }

// export default  JACConsultant;


// import React, { useState, useEffect } from 'react';
// import ExcelJS from 'exceljs';
// import { saveAs } from 'file-saver';
// import Select, { components } from 'react-select';
// import { showToast } from '../toastUtils';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';

// function JACConsultant() {
//   // const powerBiUrl = "https://app.powerbi.com/reportEmbed?reportId=31512037-cdbc-482d-b22a-30e9a887383f&autoAuth=true&ctid=b161c897-0ae2-42a0-be86-8f7e36f2049f";
//   const columnOptions = [
//     'Sno', 'Proj_Name', 'Proj_Number', 'Arch', 'ME',
//     'CS', 'QS', 'Estimated_Cons_Cost', 'Contingency', 'Total_Cons_Cost',
//     'Proj_Budget', 'Assignment_Date', 'Appointment_Date', 'Remarks'
//   ];

//   const getUserDetails = localStorage.getItem('userDetails');
//   const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';  
//   const getUserAccess = userDetails ? userDetails.access_level : '';
//   const [rows, setRows] = useState([]);
//   const [selectedColumns, setSelectedColumns] = useState(columnOptions);
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [sortDirection, setSortDirection] = useState('asc'); 

//   const handleSort = () => {
//     const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
//     setSortDirection(newSortDirection);

//     const sortedRows = [...rows].sort((a, b) => {
//       const projNameA = a.Proj_Name.toLowerCase();
//       const projNameB = b.Proj_Name.toLowerCase();

//       if (newSortDirection === 'asc') {
//         return projNameA.localeCompare(projNameB); // Ascending order
//       } else {
//         return projNameB.localeCompare(projNameA); // Descending order
//       }
//     });

//     setRows(sortedRows);
//   };
//   // const fetchWBSData = () => {
//   //   setIsLoading(true);
//   //   const requestOptions = {
//   //     method: 'GET',
//   //     //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
//   //   };

//   //   queuedApiFetch('/project/get_jac_summary_consultant', requestOptions)
//   //     .then((response) => response.json())
//   //     .then((data) => {
//   //       if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
//   //         setRows(data.data);
//   //         setIsLoading(false)
//   //       }
//   //     })
//   //     .catch((error) => console.error('Error fetching data:', error))
//   //     .finally(() => setIsLoading(false));
//   // };

//   const fetchWBSData = async () => {
//     setIsLoading(true);
  
//     const requestOptions = {
//       method: 'GET',
//       //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
//     };
  
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_BACKEND_URL}/project/get_jac_summary_consultant`,
//         requestOptions
//       );
//       const data = await response;
  
//       if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
//         setRows(data.data);
//       }
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };
  
//   useEffect(() => {
//     fetchWBSData();
//   }, []);

//   // const handleExport = async () => {
//   //   const workbook = new ExcelJS.Workbook();
//   //   const worksheet = workbook.addWorksheet('Projects');    
//   //   worksheet.columns = selectedColumns.map(column => {
//   //     const header = column.replace(/_/g, ' ').toUpperCase();
//   //     return { header, key: column };
//   //   });    
//   //   rows.forEach(row => {
//   //     const rowData = {};
  
//   //     selectedColumns.forEach(column => {
//   //       let value = row[column] || '';        
//   //       const dateValue = new Date(value);                
//   //       if (value && !isNaN(dateValue.getTime()) && typeof value === 'string' && value.trim() !== '' && /\d{4}-\d{2}-\d{2}/.test(value)) {          
//   //         rowData[column] = dateValue.toLocaleDateString('en-US');
//   //       } else {          
//   //         rowData[column] = value;
//   //       }
//   //     });      
//   //     worksheet.addRow(rowData);
//   //   });    
//   //   workbook.xlsx.writeBuffer().then(buffer => {
//   //     saveAs(new Blob([buffer]), 'JACSummaryConsultantList.xlsx');
//   //   });
//   // };  
  

//   const handleExport = async () => {
//     const workbook = new ExcelJS.Workbook();
//     const worksheet = workbook.addWorksheet('Export');    
  
//     const orderedColumns = selectedColumns.includes('Sno')
//       ? ['Sno', ...selectedColumns.filter(col => col !== 'Sno')]
//       : selectedColumns;
  
//     worksheet.columns = orderedColumns.map(column => {
//       const header = labelMapping[column] || column.replace(/_/g, ' ').toUpperCase();
//       return { header, key: column };
//     });
  
//     // Initialize auto-increment counter for "Sno"
//     let snoCounter = 1;
  
//     rows.forEach(row => {
//       const rowData = {};
  
//       orderedColumns.forEach(column => {
//         if (column === 'Sno') {
//           // Set auto-incremented value for "Sno"
//           rowData[column] = snoCounter++;
//         } else {
//           let value = row[column] || '';
//           const dateValue = new Date(value);
  
//           if (
//             value && !isNaN(dateValue.getTime()) &&
//             typeof value === 'string' && value.trim() !== '' &&
//             /\d{4}-\d{2}-\d{2}/.test(value)
//           ) {
//             // Format dates to dd-mm-yyyy
//             const day = String(dateValue.getDate()).padStart(2, '0');
//             const month = String(dateValue.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
//             const year = dateValue.getFullYear();
//             rowData[column] = `${day}-${month}-${year}`;
//           } else if (
//             ['Estimated_Cons_Cost', 'Contingency', 'Total_Cons_Cost','Proj_Budget'].includes(column) &&
//             typeof value === 'number'
//           ) {
//             // Format currency columns as $XXX,XXX.00
//             rowData[column] = new Intl.NumberFormat('en-US', {
//               style: 'currency',
//               currency: 'USD',
//               minimumFractionDigits: 0,
//               maximumFractionDigits: 0
//             }).format(value);
//           } else {
//             // Other columns
//             rowData[column] = value;
//           }
//         }
//       });
  
//       worksheet.addRow(rowData);
//     });
  
//     // Export to Excel file
//     workbook.xlsx.writeBuffer().then(buffer => {
//       saveAs(new Blob([buffer]), 'JACSummaryConsultantList.xlsx');
//     });
//   };
//   // const options = [
//   //   { value: 'selectAll', label: 'Select All' },
//   //   ...columnOptions.map(column => ({
//   //     value: column,
//   //     label: column.replace(/_/g, ' ').toUpperCase()
//   //   }))
//   // ];

//   const labelMapping = {
//     Sno: 'S.No',
//     Proj_Name: 'Project Name',
//     Proj_Number: 'Project Number',
//     Arch: 'Arch',
//     ME: 'M&E',
//     CS: 'CS',
//     QS: 'QS',
//     Estimated_Cons_Cost: 'Estimated Construction Cost',
//     Contingency: 'Contingency',
//     Total_Cons_Cost: 'Total Construction Cost',
//     Proj_Budget: 'Project Budget',
//     Assignment_Date: 'Assignment Date',
//     Appointment_Date: 'Appointment Date',
//     Remarks: 'Remarks'
// };

// const options = [
//   { value: 'selectAll', label: 'Select All' },
//   ...columnOptions.map(column => ({
//     value: column,
//     label: labelMapping[column] || column.replace(/_/g, ' ').toUpperCase()
//   }))
// ];

//   const handleColumnChange = (selectedOptions) => {
//     if (selectedOptions.some(option => option.value === 'selectAll')) {
//       if (selectedColumns.length < columnOptions.length) {
//         setSelectedColumns(columnOptions); // Select all columns
//       } else {
//         setSelectedColumns([]); // Deselect all columns
//       }
//     } else {
//       setSelectedColumns(selectedOptions.map(option => option.value));
//     }
//   };

//   const customStyles = {
//     control: (provided, state) => ({
//       ...provided,
//       width: '100%',  // Adjust width as needed
//       borderColor: state.isFocused ? '#B0B0B0' : '#E0E0E0',  // Light gray border color on focus
//       borderRadius: '8px',
//       padding: '5px',
//       boxShadow: state.isFocused ? '0 0 5px rgba(176, 176, 176, 0.5)' : 'none', // Light gray focus box-shadow
//     }),
//     menu: (provided) => ({
//       ...provided,
//       marginTop: '5px',
//       borderRadius: '8px',
//       boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)', // Lighter shadow
//     }),
//     option: (provided, state) => ({
//       ...provided,
//       padding: '10px',
//       backgroundColor: state.isSelected ? '#B0B0B0' : state.isFocused ? '#F8F8F8' : '#fff', // Lighter gray background when selected
//       color: state.isSelected ? '#fff' : '#333', // White text on selected
//       borderRadius: '4px',
//       cursor: 'pointer',
//       ':active': {
//         backgroundColor: '#B0B0B0', // Active state lighter gray background
//         color: '#fff',
//       },
//     }),
//     multiValue: (provided) => ({
//       ...provided,
//       backgroundColor: '#B0B0B0',  // Lighter gray background for multi-value
//       borderRadius: '4px',
//       color: '#fff',
//     }),
//     multiValueLabel: (provided) => ({
//       ...provided,
//       color: '#fff',
//     }),
//     multiValueRemove: (provided) => ({
//       ...provided,
//       color: '#fff',
//       ':hover': {
//         backgroundColor: '#D3D3D3',  // Lighter gray color for remove icon hover
//       },
//     }),
//   };

//   const handleEditField = (index, field, value) => {
//     const updatedRows = [...rows];
//     updatedRows[index][field] = value;
//     setRows(updatedRows);
//   };

//   // const JACSummaryConsultantList = () => {
//   //   setSubmitLoading(true);
//   //   if (!submitLoading) {
//   //     const sendData = rows;
//   //     const requestOptions = {
//   //       method: 'POST',
//   //       headers: {
//   //         'Content-Type': 'application/json',
//   //         'ngrok-skip-browser-warning': '69420'
//   //       },
//   //       body: JSON.stringify(sendData),
//   //     };
//   //     queuedApiFetch('/project/update_jac_summary_consultant', requestOptions)
//   //       .then((response) => response.json())
//   //       .then((result) => {
//   //         // alert(result.message || 'Data saved successfully');
//   //         showToast.success('Data saved successfully');
//   //         setSubmitLoading(false);          
//   //       })
//   //       .catch((error) => console.error('Error saving data:', error));
//   //   }
//   // };   
  
//   const JACSummaryConsultantList = async () => {
//     if (submitLoading) return; // Prevent multiple submissions if already loading
  
//     setSubmitLoading(true);
  
//     try {
//       const sendData = rows;
  
//       const requestOptions = {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'ngrok-skip-browser-warning': '69420',
//         },
//         body: JSON.stringify(sendData),
//       };
  
//       const response = await fetch(
//         `${process.env.REACT_APP_BACKEND_URL}/project/update_jac_summary_consultant`,
//         requestOptions
//       );
//       const result = await response;
  
//       if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
//         showToast.success('Data saved successfully');
//       } else {
//         showToast.error(result.apistatus.Status_Description || 'Error occurred. Please try again later');
//       }
//     } catch (error) {
//       console.error('Error saving data:', error);
//       showToast.error('An error occurred while saving data.');
//     } finally {
//       setSubmitLoading(false);
//     }
//   };
  
//   const CustomValueContainer = ({ children, ...props }) => {
//     const selectedOptions = props.getValue();

//     let displayValue;
//     if (selectedOptions.length <= 2) {      
//       displayValue = selectedOptions.map(opt => opt.label).join(', ');
//     } else {      
//       const displayedLabels = selectedOptions.slice(0, 2).map(opt => opt.label);
//       const moreCount = selectedOptions.length - 2;
//       displayValue = `${displayedLabels.join(', ')} + ${moreCount} more`;
//     }

//     return (
//       <components.ValueContainer {...props}>
//         <span>{displayValue}</span>
//         {children[1]}
//       </components.ValueContainer>
//     );
//   };
  
//   const CustomOption = (props) => {
//     return (
//       <components.Option {...props}>
//         <input
//           type="checkbox"
//           checked={props.isSelected}
//           onChange={() => null}
//           style={{ marginRight: 8 }}
//         />
//         <label>{props.label}</label>
//       </components.Option>
//     );
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return '';
//     const date = new Date(dateString);
//     if (isNaN(date)) return '';    
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();    
//     return `${day}-${month}-${year}`;
//   };

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
//   };
  
//   return (
//     <div className="bodywrapp" style={{width : '100%'}}>
//       <div className="header" style={{ width: '90%' }}>
//         <div className="projectwrap">
//           <div className="addwbswrap">
//             <button disabled={rows && rows.length == 0 ? true : false} onClick={handleExport}>Export</button>
//           </div>
//           <button id="submit" disabled={submitLoading || rows.length == 0 ? true : false} onClick={JACSummaryConsultantList}>Submit</button>
//         </div>
//       </div>

//       <div>
      
//       <div className="filter-wrap" style={{ width: '90%' }}>
//         <Select
//           isMulti
//           name="columns"
//           options={options}
//           value={options.filter(option => selectedColumns.includes(option.value))}
//           onChange={handleColumnChange}
//           closeMenuOnSelect={false}
//           placeholder="Select Columns"
//           hideSelectedOptions={false}
//           styles={customStyles}
//           components={{
//             ValueContainer: CustomValueContainer,
//             Option: CustomOption,
//           }}
//         />
//       </div>

//         <div className="tablewrap" style={{ width: '90%', height: 'auto' }}>
//           <table id="wbsTable">
//             <thead>
//               <tr>
//                 {selectedColumns.includes('Sno') && <th className="description-column">S.No</th>}
//                          {selectedColumns.includes('Proj_Name') && (
//                                 <th onClick={handleSort}>
//                                   Project&nbsp;Name&nbsp;&nbsp;
//                                   {sortDirection === 'asc' ? (
//                                     <FontAwesomeIcon icon={faSortUp} />
//                                   ) : (
//                                     <FontAwesomeIcon icon={faSortDown} />
//                                   )}
//                                 </th>
//                               )}
//                 {selectedColumns.includes('Proj_Number') && <th className="description-column">Project Number</th>}
//                 {selectedColumns.includes('Arch') && <th className="description-column">Arch</th>}
//                 {selectedColumns.includes('ME') && <th className="description-column">M&E</th>}
//                 {selectedColumns.includes('CS') && <th className="description-column">CS</th>}
//                 {selectedColumns.includes('QS') && <th className="description-column">QS</th>}
//                 {selectedColumns.includes('Estimated_Cons_Cost') && <th className="description-column">Estimated Construction Cost</th>}
//                 {selectedColumns.includes('Contingency') && <th className="description-column">Contingency</th>}
//                 {selectedColumns.includes('Total_Cons_Cost') && <th className="description-column">Total Construction Cost</th>}
//                 {selectedColumns.includes('Proj_Budget') && <th className="description-column">Project Budget</th>}
//                 {selectedColumns.includes('Assignment_Date') && <th style={{ minWidth: '100px' }} className="description-column">Assignment Date</th>}
//                 {selectedColumns.includes('Appointment_Date') && <th style={{ minWidth: '100px' }} className="description-column">Appointment Date</th>}
//                 {selectedColumns.includes('Remarks') && <th className="description-column">Remarks</th>}                
//               </tr>
//             </thead>
//             <tbody>
//               {selectedColumns.length === 0 ? (
//                   <tr>
//                     <td colSpan='14' style={{ textAlign: 'center', verticalAlign: 'middle', height: '100px', padding: '20px' }}>Please Select any one column</td>
//                   </tr>
//                 )
//                 :
//                   rows.length === 0 ? (
//                     <tr>
//                       <td colSpan='14' style={{ textAlign: 'center', verticalAlign: 'middle', height: '100px', padding: '20px' }}>{isLoading ? 'Loading...':'No records found'}</td>
//                     </tr>
//                   ) 
//                   :
//                   (
//                     rows.map((row, index) => (
//                       <tr key={index}>
//                         {selectedColumns.includes('Sno') && <td>{index + 1}</td>}
//                         {selectedColumns.includes('Proj_Name') && <td>{row.Proj_Name}</td>}
//                         {selectedColumns.includes('Proj_Number') && <td>{row.Proj_Number}</td>}
//                         {selectedColumns.includes('Arch') && <td>{row.Arch}</td>}
//                         {selectedColumns.includes('ME') && <td>{row.ME}</td>}
//                         {selectedColumns.includes('CS') && <td>{row.CS}</td>}
//                         {selectedColumns.includes('QS') && <td>{row.QS}</td>}
//                         {selectedColumns.includes('Estimated_Cons_Cost') && <td>{formatCurrency(row.Estimated_Cons_Cost)}</td>}
//                         {selectedColumns.includes('Contingency') && <td>{formatCurrency(row.Contingency)}</td>}
//                         {selectedColumns.includes('Total_Cons_Cost') && <td>{formatCurrency(row.Total_Cons_Cost)}</td>}
//                         {selectedColumns.includes('Proj_Budget') && <td>{formatCurrency(row.Proj_Budget)}</td>}
//                         {selectedColumns.includes('Assignment_Date') && <td>{formatDate(row.Assignment_Date)}</td>}
//                         {selectedColumns.includes('Appointment_Date') && <td>{formatDate(row.Appointment_Date)}</td>}
//                         {selectedColumns.includes('Remarks') && <td>
//                           <input
//                             disabled={getUserAccess == 'project_admin' ? false : true}
//                             type="text"
//                             value={row.Remarks}
//                             onChange={(e) =>
//                               handleEditField(index, 'Remarks', e.target.value)
//                             }
//                           />
//                         </td>}
//                       </tr>
//                     ))
//                   )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default JACConsultant;
